import {Component, OnInit} from '@angular/core';
import {FormControl, FormGroup, ValidatorFn} from '@angular/forms';
import {SchemaService} from '../../services/schema.service';
import {ValidationService} from '../../services/validation.service';
import {ErrorNotificationService} from '../../services/error-notification.service';
import {AuthService, GUEST_PSW, GUEST_USERNAME} from '../../services/auth.service';
import {BBEnv} from '../../environments/bb-env';
import {ActivatedRoute, Router} from '@angular/router';
import {MatomoTracker} from 'ngx-matomo-client';

@Component({
  selector: 'app-login',
  templateUrl: './login.page.html',
  styleUrls: ['./login.page.scss']
})
export class LoginPage implements OnInit {
  username = new FormControl('', this.validatorFnForProperty('username'));
  password = new FormControl('', this.validatorFnForProperty('password'));

  loginFormGroup: FormGroup;
  showLanguageSwitcher = false;

  constructor(
    private matomoTracker: MatomoTracker,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private schemaService: SchemaService,
    private validationService: ValidationService,
    private errorNotificationService: ErrorNotificationService,
    private authService: AuthService) {
    this.loginFormGroup = new FormGroup({
      username: this.username,
      password: this.password
    });
  }

  private listenToRouteParams() {
    this.activatedRoute.params.subscribe(async params => {
      if (params['username'] && params['password']) {
        this.username.setValue(params['username']);
        this.password.setValue(params['password']);
      }
    });
  }

  ngOnInit() {
    this.listenToRouteParams();
  }

  isValid(): boolean {
    return this.loginFormGroup.valid;
  }

  usernameContainsEmail(): boolean {
    return this.username?.value?.indexOf('@') > -1;
  }

  private validatorFnForProperty(property: string): ValidatorFn[] {
    // todo: maybe it would be nicer to not have to get the schema from schemaservice ourselves,
    return this.validationService.getFormValidator(this.schemaService.loginCredentialsSchema, property);
  }

  async onLogin() {
    try {
      await this.authService.login({
        username: this.username.value,
        password: this.password.value
      });
      await this.router.navigate(['tabs']);
      this.matomoTracker.trackEvent('auth', 'login');
    } catch (err) {
      if (typeof err.bbErrorType === 'undefined') {
        throw err;
      }
      await this.errorNotificationService.showBBError(err);
    }
  }

  onTestUser() {
    this.username.setValue('testuser');
    this.password.setValue('testuser');
  }

  async onResetPassword() {
    await this.router.navigate(['/reset-password']);
  }

  isNotProd() {
    return !BBEnv.isProduction();
  }

  async loginAsGuest() {
    this.username.setValue(GUEST_USERNAME);
    this.password.setValue(GUEST_PSW);
    await this.onLogin();
  }
}
